/* eslint-disable */
// @ts-nocheck

export const initializeSupportWidget = () => {
  !(function () {
    if (!(window.Gleap = window.Gleap || []).invoked) {
      window.GleapActions = [];
      var e = new Proxy(
        { invoked: !0 },
        {
          get: function (e, n) {
            return "invoked" === n
              ? e.invoked
              : function () {
                  var e = Array.prototype.slice.call(arguments);
                  window.GleapActions.push({ e: n, a: e });
                };
          },
          set: function (e, n, t) {
            return ((e[n] = t), !0);
          },
        }
      );
      window.Gleap = e;
      var n = document.getElementsByTagName("head")[0],
        t = document.createElement("script");
      ((t.type = "text/javascript"),
        (t.async = !0),
        (t.src = "https://sdk.gleap.io/latest/index.js"),
        n.appendChild(t),
        window.Gleap.initialize("f1P2o4Y3DPfNYzPZUESRb05s7xWP6F3s"));
    }
  })();
};
